import BulletTypography from '@/common/components/base/typography/BulletTypography.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { Flex } from 'styled-system/jsx';
import { TelephoneDetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import TelephoneIcon from '@/common/assets/icons/phoneIcon.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon.tsx';
import { token } from 'styled-system/tokens';

export default ({
  value,
  keyName,
  backgroundColor = 'black-3',
  hasBullet = true,
  telephone,
}: Omit<TelephoneDetailCardItemData, 'value'> & {
  value: string;
}) => {
  return (
    <Flex justifyContent="space-between">
      {hasBullet ? (
        <BulletTypography
          backgroundColor={backgroundColor}
          textStyle="b2"
          color="black-3"
          flexShrink={0}
        >
          {keyName}
        </BulletTypography>
      ) : (
        <Typography flexShrink={0} textStyle="b2" color="black-3">
          {keyName}
        </Typography>
      )}
      <Flex alignItems="center">
        <a href={`tel:${telephone}`}>
          <CustomIcon backgroundColor="green-4" width={26} height={26}>
            <TelephoneIcon stroke={token('colors.green')} />
          </CustomIcon>
        </a>
        <Typography textAlign="left" mr="7px" textStyle="b2" color="black-1">
          {value}
        </Typography>
      </Flex>
    </Flex>
  );
};
